













import Vue from "vue";
import Component from "vue-class-component";
import store from "../store";

Vue.filter("formatTemps", function (temps?: number) {
  if (temps) {
    return (temps - (temps %= 60)) / 60 + (9 < temps ? ":" : ":0") + temps;
  }
});

@Component
export default class Minuteur extends Vue {
  get verrouDateFin(): number | null {
    return store.state.minuteur.verrouDateFin;
  }

  get tempsRestantEnSecondes(): number | null {
    return store.state.minuteur.tempsRestantEnSeconde;
  }
}
